import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-vms-brand-logo',
  standalone: true,
  imports: [CommonModule],
  template: `
    <img
      class="vms-brand-logo"
      [ngClass]="sizeClass"
      src="assets/branding/vms-logo.svg"
      alt="VMS"
      decoding="async"
    />
  `,
  styles: [
    `
      .vms-brand-logo {
        display: block;
        object-fit: contain;
        flex-shrink: 0;
      }

      .vms-brand-logo--sm {
        height: 2.25rem;
        width: auto;
      }

      .vms-brand-logo--md {
        height: 3.5rem;
        width: auto;
      }

      .vms-brand-logo--lg {
        height: 5.5rem;
        width: auto;
      }
    `
  ]
})
export class VmsBrandLogoComponent {
  @Input() size: 'sm' | 'md' | 'lg' = 'md';

  get sizeClass(): string {
    return `vms-brand-logo--${this.size}`;
  }
}
